<template>
	<div class="card" v-if="editorTranslators !== null && Object.keys(editorTranslators).length > 0">
		<header class="card-header language-list">
			<h3 class="card-title">Article Translators</h3>
		</header>
		<div class="card-body">
			<div class="table-responsive">
				<table>
					<thead>
						<tr>
							<th>Language</th>
							<th>Translator</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(translatorObject,languageId) in editorTranslators">
							<td>{{ findByKeyAndValue(availableLanguages, 'id', languageId).title }}</td>
							<td>
								<slot v-for="translators in translatorObject" v-if="translatorObject.length > 0">
									{{ translators.full_name }}
								</slot>
								<slot v-if="translatorObject.length === 0">none</slot>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		editorTranslators: {
			type: Array,
			required: false,
			default: null,
		}
	},
	data() {
		return {
			availableLanguages: this.$availableLanguages,
		}
	},
	methods: {
		findByKeyAndValue: function (object, key, value) {
			let result = {
				id: null
			};
			Object.keys(object).some(function (index) {
				if (object[index][key] == value) {
					result = object[index];
					return result;
				}
			});
			return result;
		}
	}
}
</script>

<style scoped>

</style>
